import { useEffect, useRef, useState } from "react";

const Marquee = ({ children, speed = 1, resumeDelay = 2000 }) => {
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const posRef = useRef(0);
  const directionRef = useRef(-1); // -1 = left, 1 = right
  const [paused, setPaused] = useState(false);
  const resumeTimeoutRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const track = trackRef.current;
    if (!container || !track) return;

    let raf;

    const animate = () => {
      if (!paused) {
        const containerWidth = container.offsetWidth;
        const trackWidth = track.scrollWidth;
        const maxScroll = trackWidth - containerWidth;

        posRef.current += directionRef.current * speed;

        if (posRef.current <= -maxScroll) {
          posRef.current = -maxScroll;
          directionRef.current = 1;
        } else if (posRef.current >= 0) {
          posRef.current = 0;
          directionRef.current = -1;
        }

        track.style.transform = `translateX(${posRef.current}px)`;
      }

      raf = requestAnimationFrame(animate);
    };

    raf = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(raf);
    };
  }, [speed, paused]);

  const handleMouseEnter = () => {
    setPaused(true);
    if (resumeTimeoutRef.current) clearTimeout(resumeTimeoutRef.current);

    resumeTimeoutRef.current = setTimeout(() => {
      setPaused(false);
    }, resumeDelay);
  };

  return (
    <div
      ref={containerRef}
      className="overflow-hidden"
      style={{ width: "100%", cursor: "pointer" }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onClick={handleMouseEnter}
    >
      <div
        ref={trackRef}
        className="d-flex align-items-center gap-2"
        style={{
          whiteSpace: "nowrap",
          willChange: "transform",
          transition: "transform 0.02s linear",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Marquee;
